import { render, staticRenderFns } from "./access_without_code_cam.vue?vue&type=template&id=2467d086&scoped=true"
import script from "./access_without_code_cam.vue?vue&type=script&lang=js"
export * from "./access_without_code_cam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2467d086",
  null
  
)

export default component.exports